import {
    putRouteStatusCancelLoading,
    putRouteStatusCancelRequest,
    putRouteStatusCancelSuccess,
    putRouteStatusCancelReject,
    putRouteStatusCancelReset
} from "../../actions/route/putStatusCancelRoute";

export const putRouteStatusCancel = (formData) => async (dispatch, getState) => {
    dispatch(putRouteStatusCancelLoading());
    try {
        const { data } = await putRouteStatusCancelRequest(formData, getState);
        dispatch(putRouteStatusCancelSuccess(data))
    } catch (error) {
        dispatch(putRouteStatusCancelReject(error))
    } finally {
        setTimeout(() => { dispatch(putRouteStatusCancelReset()) }, 3000);
    }
    return Promise.resolve();
};